// Generated by purs version 0.15.15
var ok = {
    success: true
};
export {
    ok
};
//# sourceMappingURL=index.js.map
